module.exports = __webpack_public_path__ + "static/forecast/fresh-snow/thigh-04d52531f1e84e42164d9d57d8b0626a.svg";